// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"372":"f3097652","573":"6cba0461","984":"f3097652"}[chunkId] + ".css";
};